import { Box, Divider, Stack } from "@mui/material";
import React from "react";
import CSkeleton from "../../CSkeleton/CSkeleton";

const EFTSkeleton = () => {
  return (
    <Box
      key={"bank"}
      display={"flex"}
      flexDirection={"column"}
      p={2}
      mt={2}
      gap={2}
      sx={{ borderRadius: "12px", border: " 2px solid #F1F5F9" }}
    >
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          <CSkeleton width={106} height={25} />
        </div>
      </Stack>
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          <CSkeleton width={100} height={20} />
        </div>
        <div className="text-sm font-semibold text-cardValue">
          <CSkeleton width={100} height={20} />
        </div>
      </Stack>
      <Divider className="ml:hidden" sx={{ borderColor: "#E2E8F0" }} />
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-norma text-cardLabel flex">
          <CSkeleton width={150} height={20} />
        </div>
        <div className="text-sm font-semibold text-cardValue">
          <CSkeleton width={200} height={20} />
        </div>
      </Stack>
      <Divider className="ml:hidden" sx={{ borderColor: "#E2E8F0" }} />
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          <CSkeleton width={100} height={20} />
        </div>
        <div className="text-sm font-semibold text-cardValue">
          <CSkeleton width={200} height={20} />
        </div>
      </Stack>
      <Divider className="ml:hidden" sx={{ borderColor: "#E2E8F0" }} />
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          <CSkeleton width={170} height={20} />
        </div>
        <div className="text-sm font-semibold text-cardValue">
          <CSkeleton width={100} height={20} />
        </div>
      </Stack>
    </Box>
  );
};

export default EFTSkeleton;
